module.exports = __webpack_public_path__ + "static/media/07GalleryPuppets.0581820e.jpeg";